import { ErrorMessage, Form, Formik } from "formik";
import { toast } from "react-toastify";
import axios from "axios";
import * as Yup from "yup";
import Button from "../components/Button.js";
import { useNavigate } from "react-router";

const Input = ({
  name,
  title,
  placeholder = "",
  type = "input",
  children,
  className,
  onChange,
  error = false,
  ...rest
}) => {
  return (
    <div className="contact-input-field">
      <input
        as={type}
        name={name}
        id={name}
        label={title}
        margin="dense"
        placeholder={placeholder}
        onChange={onChange}
        className={`${className}${error ? " contact-input-error" : ""}`}
        {...rest}
      >
        {children}
      </input>
      <ErrorMessage
        component="div"
        name={name}
        className="contact-error-message"
      />
    </div>
  );
};

const Contact = () => {
  const navigate = useNavigate();
  const validationSchema = Yup.object().shape({
    firstName: Yup.string()
      .min(2, "the first name is too short")
      .max(70, "the first name is too long")
      .required("the first name is required"),
    lastName: Yup.string()
      .min(2, "the last name is too short")
      .max(70, "the last name is too long"),
    email: Yup.string()
      .email()
      .max(255, "email address is too long")
      .required("email adress is required"),
    subject: Yup.string()
      .min(5, "email subject is too short")
      .max(70, "email subject too long")
      .required("email subject is required"),
    message: Yup.string()
      .min(50, "message is too short")
      .max(10000, "message is too long")
      .required("message is required"),
  });
  return (
    <div className="contact-page">
      <Formik
        initialValues={{
          firstName: "",
          lastName: "",
          email: "",
          subject: "",
          message: "",
        }}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          const body = {
            message: values.message,
            subject: values.subject,
            name: `${values.firstName} ${values.lastName}`,
            email: values.email,
          };
          axios
            .post("https://wb-blog-api.onrender.com/send", body, {
              headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
              },
            })
            .then(() => {
              setSubmitting(false);
              toast.success("the email was send sucessfully!");
              navigate("/about");
            })
            .catch((error) => {
              setSubmitting(false);
              toast.error(error.message);
            });
        }}
      >
        {({
          values,
          errors,
          // touched,
          isSubmitting,
          handleChange,
          // setFieldValue,
        }) => (
          <Form className="contact-form">
            <div className="input-name-wrapper">
              <label className="form-label" htmlFor="name">
                Name
              </label>
              <div className="input-name">
                <div className="name-field">
                  <Input
                    className="form-input"
                    type="text"
                    id="firstName"
                    name="firstName"
                    onChange={handleChange}
                    error={!!errors.firstName}
                    value={values.firstName}
                  />
                  {!errors.firstName && (
                    <span className="name-span">First Name</span>
                  )}
                </div>
                <div className="name-field">
                  <Input
                    className="form-input"
                    type="text"
                    id="lastName"
                    name="lastName"
                    onChange={handleChange}
                    error={!!errors.lastName}
                    value={values.lastName}
                  />
                  {!errors.lastName && (
                    <span className="name-span">Last Name</span>
                  )}
                </div>
              </div>
            </div>
            <div className="input-email">
              <label className="form-label" htmlFor="email">
                Email
              </label>
              <Input
                className="form-input"
                type="email"
                id="email"
                name="email"
                onChange={handleChange}
                error={!!errors.email}
                value={values.email}
              />
            </div>
            <div className="input-subject">
              <label className="form-label" htmlFor="subject">
                Subject
              </label>
              <Input
                className="form-input"
                type="text"
                id="subject"
                name="subject"
                onChange={handleChange}
                error={!!errors.subject}
                value={values.subject}
              />
            </div>
            <div className="input-message">
              <label className="form-label" htmlFor="message">
                Message
              </label>

              <div className="contact-input-field">
                <textarea
                  className="message-area"
                  style={errors.message && { borderColor: "red" }}
                  id="message"
                  name="message"
                  onChange={handleChange}
                  value={values.message}
                />
                <ErrorMessage
                  component="div"
                  name="message"
                  className="contact-error-message"
                />
              </div>
            </div>
            <Button
              text="SUBMIT"
              type="submit"
              value="submit"
              loading={isSubmitting}
              disabled={isSubmitting}
              style={{ width: "124px", height: "40px" }}
            />
          </Form>
        )}
      </Formik>
    </div>
  );
};
export default Contact;
